import { LoginCallback } from "@okta/okta-react";

import Loading from "@/pages/Loading";

/** Handles the Okta redirect back to `/login/callback` (exchanges the auth code for tokens). */
const LoginCallbackRoute = () => <LoginCallback loadingElement={<Loading />} />;

export default LoginCallbackRoute;
